<template>
  <div class="comment">
    <!-- <div class="comment-bg" @click="handleClose"></div> -->
    <div class="comment-div" id="scroll">
      <van-loading type="spinner" class="loading" v-if="isLoading" />
      <div class="comment-title">评论 {{ details && details.commentNum }}</div>
      <van-list
        id="list"
        v-model="commentState.loading"
        :finished="commentState && commentState.finished"
        :offset="10"
        :finished-text="commentState.finishText"
        @load="handleGetCommentList"
        class="comment-block"
      >
        <div
          class="header-div"
          v-for="(item, index) in commentListArr"
          :key="index"
        >
          <img :src="item && item.userHeadPic" class="header-cover" alt="" />
          <div class="header-con">
            <div class="header-name">
              {{ item && item.userName }}
              <div class="isShow" v-if="item.isShow === 0">
                {{ auditStatusObj[item.isShow] }}
              </div>
              <div class="up-div" v-if="item && item.isTop">置顶</div>
              <div class="set-div" v-if="`${roles.peSign}` === '1'">
                <img
                  @click="handleClickShowSetUP(item)"
                  src="../../assets/images/zone/img46.png"
                  class="set-up"
                  alt="/"
                />
              </div>
            </div>
            <div class="comment-con">
              <div class="con-txt">{{ item && item.content }}</div>
              <div class="con-time">
                <div class="time-txt">{{ item && item.times }}</div>
                <div
                  class="reply"
                  v-if="`${item.isShow}` === '1'"
                  @click="handleClickReply(item)"
                >
                  回复
                  <img
                    src="../../assets/images/zone/img21.png"
                    class="icon-reply"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div v-if="item && item.answerInfo" class="comment-imgs">
              <img
                v-if="item && item.answerInfo.url"
                @click="handleShowImg(item)"
                :src="item.answerInfo.url"
                class="commimg"
                alt=""
              />
              <div class="custom-mask" @click="hidePreviewIfMaskClicked">
                <van-image-preview
                  ref="imagePreview"
                  v-model="showimg"
                  :images="[coverUrl]"
                  :closeable="true"
                />
              </div>
            </div>
            <div
              class="header-div"
              v-for="(item_comm, index_comm) in item.areaCommentListsDTOS"
              :key="index_comm"
            >
              <img :src="item_comm && item_comm.userHeadPic" class="header-cover" alt="" />
              <div class="header-con">
                <div class="header-name">
                  <!-- <div class="txt1" v-if="`${detailData.userIdentity}` === '2'">
                    管理员
                  </div>
                  <div class="txt1 txt2" v-else>{{ iepUserDTO && iepUserDTO.realName }}</div> -->
                  {{ item_comm && item_comm.userName }}
                  <div class="isShow" v-if="item_comm.isShow === 0">
                    {{ auditStatusObj[item_comm.isShow] }}
                  </div>
                </div>
                <div class="comment-con">
                  <div class="con-txt">{{ item_comm && item_comm.content }}</div>
                  <div class="con-time">
                    <div class="time-txt">{{ item_comm && item_comm.times }}</div>
                  </div>
                </div>
                <div v-if="item_comm && item_comm.answerInfo" class="comment-imgs">
                  <img
                    v-if="item_comm && item_comm.answerInfo.url"
                    @click="handleShowImg(item_comm)"
                    :src="item_comm.answerInfo.url"
                    class="commimg"
                    alt=""
                  />
                  <div class="custom-mask" @click="hidePreviewIfMaskClicked">
                    <van-image-preview
                      ref="imagePreview"
                      v-model="showimg"
                      :images="[coverUrl]"
                      :closeable="true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <commentDialogVue
      ref="commentDialog"
      :detailData="details"
      :files="fileInfo"
      v-show="show"
    ></commentDialogVue>
    <div v-if="showModal" class="modal">
      <!-- Modal content -->
      <div class="modal-content">
        <p class="model-btn model-cancel" @click="handleSetUp">{{clickItem.isTop ? '取消置顶' : '置顶'}}</p>
        <p class="model-btn cancel-btn" @click="showModal = !showModal">取消</p>
      </div>
    </div>
  </div>
</template>

<script>
import commentPop from './compontents/commentPop.vue'
import { auditStatusObj } from './data'
import { getCommentDefaultList, commentUserTop, filesInfo, postDetails } from '@/api/zone'
import withRouteTracking from '@/utils/withRouteTracking'
import commentDialogVue from './compontents/commentDialog.vue'
import { ImagePreview } from 'vant'

const UserProfile = {
  name: 'comment',
  props: {
    postId: '',
    detailData: {},
    files: []
  },
  data() {
    return {
      analysisVideo: {},
      // 筛选项分页
      commentState: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了',
      },
      commentListArr: [],
      isNone: false,
      commentableId: '',
      targetContent: '',
      total: 0,
      auditStatusObj,
      details: {},
      isLoading: true,
      show: false,
      showModal: false,
      clickItem: {},
      showimg: false,
      coverUrl: '',
      fileInfo: []
    }
  },
  components: { commentPop, commentDialogVue, ImagePreview },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    roles() {
      return sessionStorage.getItem('roleResult') ? JSON.parse(sessionStorage.getItem('roleResult')) : {}
    }
  },
  watch: {
    detailData(newval) {
      this.details = newval
    },
  },
  mounted() {
    if (this.$route.query.postbarId) {
      postDetails({ postbarId: this.$route.query.postbarId }).then(res => {
        this.details = res.data
        if (this.details.adminFileMainId && this.fileInfo.length <= 0) {
          filesInfo({ mainId: this.details.adminFileMainId }).then((res) => {
            this.fileInfo = res.data
          })
        }
      })
    }
  },
  methods: {
    handleShowImg(item) {
      this.showimg = !this.showimg
      this.coverUrl = item.answerInfo.url
    },
    // 重置帖子
    handleGetlist() {
      this.commentListArr = []
      this.commentState.pageNo = 1
      this.handleGetCommentList()
    },
    // 点击关闭
    hidePreviewIfMaskClicked (event) {
      // 判断点击是否发生在预览图片本身之外
      if (event.target.classList.contains('van-image-preview__swipe-item')) {
        this.showimg = false
        document.removeEventListener('mousedown', this.handleMouseDown)
      }
    },
    handleSetUp() {
      if (!(`${this.roles.peSign}` === '1')) {
        this.$toast('只有管理员才能置顶评论！')
        return
      }
      let params = {
        id: this.clickItem.id,
        isTop: !this.clickItem.isTop ? '1' : '0'
      }
      commentUserTop(params).then(res => {
        if (this.clickItem.isTop) {
          this.$toast('取消置顶成功')
        } else {
          this.$toast('置顶成功')
        }
        this.showModal = false
        this.commentListArr = []
        this.commentState.pageNo = 1
        this.handleGetCommentList()
      }).catch(err => {
        console.error(err)
        this.$toast(err.msg)
        this.showModal = false
      })
    },
    handleClickShowSetUP(item) {
      this.clickItem = item
      this.showModal = true
    },
    handleClose() {
      this.$parent.showComment = false
      this.$parent.show = true
      this.commentableId = ''
    },
    handleClickReply(item) {
      this.show = true
      this.commentableId = item.id
      this.$refs.commentDialog.commentableId = item.id
      this.$refs.commentDialog.targetContent = item.content
    },
    handleGetCommentList() {
      if (this.$route.query.postbarId) {
        this.postId = this.$route.query.postbarId
      }
      let params = {
        pageNum: this.commentState.pageNo,
        pageSize: this.commentState.pageSize,
        commentableId: this.postId,
        // 类型类型1rtc专区2病例交流3评论
        type: '1',
      }
      getCommentDefaultList(params)
        .then((res) => {
          this.isLoading = false
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.commentState.loading = false
              this.commentState.finished = true
              return false
            }
            this.total = res.data.total
            res.data.list = res.data.list.map((item) => {
              item.times = this.$moment(item.createTime * 1).format(
                'YY-MM-DD HH:mm:ss'
              )
              if (item.areaCommentListsDTOS.length > 0) {
                item.areaCommentListsDTOS = item.areaCommentListsDTOS.map(
                  (comm) => {
                    comm.times = this.$moment(comm.createTime * 1).format(
                      'YY-MM-DD HH:mm:ss'
                    )
                    return comm
                  }
                )
              }
              return item
            })
            if (res.data.list.length < this.commentState.pageSize) {
              this.commentState.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.commentListArr = this.commentListArr.concat(res.data.list)
            }
            this.commentState.pageNo++
            if (this.commentListArr.length === 0) {
              this.isNone = true
              this.commentState.finishText = ''
            }
          }
        })
        .catch((err) => {
          this.$toast.clear()
          console.log('err:', err)
        })
        .finally(() => {
          this.commentState.loading = false
        })
    },
    handleSucc(params) {
      let addArr = {
        userName: this.userInfo.realName,
        content: params.content,
        times: this.$moment(new Date()).format('YY-MM-DD HH:mm:ss'),
        userHeadPic: this.userInfo.headPicUrl,
        id: params.id,
        isShow: 0,
      }
      this.total++
      if (!this.commentableId) {
        addArr.areaCommentListsDTOS = []
        this.commentListArr.push(addArr)
      } else {
        this.commentListArr.map((res, index) => {
          if (res.id === params.commentableId) {
            this.commentListArr[index].areaCommentListsDTOS.push(addArr)
          }
        })
      }
      this.commentableId = ''
    },
  },
}
export default withRouteTracking(UserProfile)
</script>
<style scoped lang="less">
.comment {
  padding: 0 14px;
  box-sizing: border-box;

  .comment-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .comment-div {
    z-index: 99;
    width: 100%;
    min-height: 200px;
    background-color: #fff;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    .loading {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -30%);
    }
  }

  .comment-title {
    line-height: 48px;
    font-size: 16px;
    color: #000000;
    font-weight: 600;
    margin-bottom: 4px;
    position: sticky;
    top: 0;
    left: 20px;
    width: 100%;
    z-index: 9;
    background-color: #fff;
  }

  .comment-block {
    width: 100%;
  }

  .header-div {
    display: flex;

    .header-cover {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 8px;
      object-fit: cover;
    }

    .header-con {
      flex: 1;
      .header-name {
        font-size: 14px;
        color: #000000;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 4px;
        display: flex;
        align-items: center;

        .isShow {
          color: #EB1700;
          font-size: 12px;
          margin-left: 10px;
          font-weight: 400;
        }

        .up-div {
          font-family: PingFang HK, PingFang HK;
          font-weight: 400;
          font-size: 12px;
          color: #EB1700;
          position: relative;
          height: 10px;
          line-height: 10px;
          border-left: 1px solid #b1b1b1;
          padding-left: 6px;
          margin-left: 6px;
        }
        .set-div {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          .set-up {
            width: 17px;
            display: block;
          }
        }
      }

      .comment-con {
        margin-bottom: 16px;
      }

      .commimg {
        width: 200px;
        margin-bottom: 16px;
        display: block;
      }

      .con-txt {
        font-size: 14px;
        color: #000000;
        line-height: 20px;
        margin-bottom: 4px;
        word-break: break-all;
      }

      .con-time {
        display: flex;
        align-items: center;
        height: 20px;
        line-height: 20px;

        .time-txt {
          color: #b1b1b1;
          font-size: 12px;
          margin-right: 6px;
        }

        .reply {
          display: flex;
          align-items: center;
          padding-left: 8px;
          color: #EB1700;
          font-size: 12px;
          height: 10px;
          border-left: 1px solid #b1b1b1;

          .icon-reply {
            width: 16px;
            display: block;
            margin-left: 3px;
          }
        }
      }
    }
  }
}

/* The Modal (background) */
.modal {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  bottom: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content */
.modal-content {
  width: 90%;
  text-align: center;
  position: absolute;
  bottom: 20px;
  left: 5%;

  .model-btn {
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    border-radius: 6px;
    background-color: #fff;
    color: #000000;
    font-weight: 600;
    margin-bottom: 8px;
    &.model-cancel {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 16px;
      color: #EB1700;
    }
  }
}

/* The Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  cursor: pointer;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/comment.vue